import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { DeleteWebhookPage } from './delete-webhook.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: DeleteWebhookPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [DeleteWebhookPage],
})
export class DeleteWebhookPageModule {}
